var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
const calc = (progress, circ) => {
    return (circ - circ * progress) / 100;
};
const ProgressCircleContainerStyle = styled.div `
  padding: ${props => props.noPadding ? '0' : props.theme.paddingsMargins.themePadding};
  position: relative;
  width: ${props => (props.size + 10) + 'px'};
  height: ${props => (props.size + 10) + 'px'};
`;
const ProgressCircleContainer = styled.svg `
  width: 100%;
  height: 100%;
`;
const CircleStyle = styled.circle `
  fill: none;
  stroke: ${props => props.bgCircleColor ? props.theme.utils.getColor(props.bgCircleColor) : props.theme.boxes.progresBackground};
  stroke-linecap: round;
  stroke-width: ${props => props.strokeWidth};
  transform: translate(5px, 5px);
`;
const CircleProgress = styled(CircleStyle) `
  stroke-dasharray: ${props => 2 * Math.PI * props.r};
  stroke-dashoffset: ${props => calc(props.progress - 100, 2 * Math.PI * props.r)};
  stroke-width: ${props => props.strokeWidth};
  stroke: ${props => props.progress === 0 ? '#dcdcdc' : props.theme.utils.getColor(props.color)};
`;
const CircleProgressValue = styled.div `
  position: absolute;
  top: ${props => props.progressNumberPosition.top};
  left: ${props => props.progressNumberPosition.left};
`;
const ProgressCircle = (_a) => {
    var { size = 150, progress = 70, textSize = 'article', isShowPercentage = true, color = 'main', bgCircleColor, strokeWidth = 10, progressNumberPosition = { top: '45%', left: '45%' }, noPadding = false } = _a, props = __rest(_a, ["size", "progress", "textSize", "isShowPercentage", "color", "bgCircleColor", "strokeWidth", "progressNumberPosition", "noPadding"]);
    const radius = size / 2;
    return (_jsxs(ProgressCircleContainerStyle, Object.assign({ size: size, noPadding: noPadding }, props, { children: [_jsxs(ProgressCircleContainer, { children: [_jsx(CircleStyle, { cx: radius, cy: radius, r: radius, strokeWidth: strokeWidth, bgCircleColor: bgCircleColor }), _jsx(CircleProgress, { bgCircleColor: bgCircleColor, color: color, strokeWidth: strokeWidth, progress: progress, cx: radius, cy: radius, r: radius })] }), isShowPercentage &&
                _jsx(CircleProgressValue, Object.assign({ progressNumberPosition: progressNumberPosition }, { children: _jsxs(Typography, Object.assign({ size: textSize, color: color }, { children: [progress, "%"] })) }))] })));
};
export default ProgressCircle;
